import Vue from 'vue';
import Router from 'vue-router';
import AgreeToTerms from './views/AgreeToTerms.vue';
import EmploymentInformation from './views/EmploymentInformation.vue';
import SystemError from './views/SystemError.vue';
import MinorLoginError from './views/MinorLoginError.vue';
import Login from './views/Login.vue';
import PersonalInformation from './views/PersonalInformation.vue';
import TrustDocVerifyWait from './views/TrustDocVerifyWait.vue';
import TrustDocVerifyInitiate from './views/TrustDocVerifyInitiate.vue';
import TrustDocVerifyResendSMS from './views/TrustDocVerifyResendSMS.vue';
import TrustDocVerifyNotComplete from './views/TrustDocVerifyNotComplete.vue';
import TrustCustomerNotFound from './views/TrustCustomerNotFound.vue';
import TrustCustomerIdentityMisMatch from './views/TrustCustomerIdentityMisMatch.vue';
import TrustCustomerContactMisMatch from './views/TrustCustomerContactMisMatch.vue';
import TrustIdentityVerificationFailure from './views/TrustIdentityVerificationFailure.vue';
import PersonalInformationIS from './views/PersonalInformationIS.vue';
import ReviewAndConfirm from './views/ReviewAndConfirm.vue';
import ReviewAndConfirmIS from './views/ReviewAndConfirmIS.vue';
import WelcomeBack from './views/WelcomeBack.vue';
import FinalPage from './views/FinalPage.vue';
import SessionTimeOut from './views/SessionTimeout.vue';
import FinalPageIRRL from './views/FinalPageIRRL.vue';
import CustomerIGO from './views/CustomerIGO.vue';
import JointEmploymentInformation from './views/JointEmploymentInformation.vue';
import JointPersonalInformation from './views/JointPersonalInformation.vue';
import TrustLogin from './views/TrustLogin.vue';
import TrustInformation from './views/TrustInformation.vue';
import TrustRole from './views/TrustRole.vue';
import TrustDashboard from './views/TrustDashboard.vue';
import TrustSsnMismatch from './views/TrustSsnMismatch.vue';
import TrustAdditionalRole from './views/TrustAdditionalRole.vue';
import TrustAuthority from './views/TrustAuthority.vue';
import TrustPaper from './views/TrustPaper.vue';
import TrustReviewAndConfirm from './views/TrustReviewAndConfirm.vue';
import TrustSigning from './views/TrustSigning.vue';
import TrustFinalPage from './views/TrustFinalPage.vue';
import TrustRetrievePage from './views/TrustRetrievePage.vue';
import TrustPendingRecord from './views/TrustPendingRecord.vue';
import TrustEmailDashboard from './views/TrustEmailDashboard.vue';
import TrustEmailDashboardEcta from './views/TrustEmailDashboardEcta.vue';
import TrustNextSteps from './views/TrustNextSteps.vue';
import TrustBackToMaestro from './views/TrustBackToMaestro.vue';
import TrustNotEditableError from './views/TrustNotEditableError.vue';
import JointContactInformation from './views/JointContactInformation.vue';
import EligibleAccountError from './views/EligibleAccountError.vue';
import Retrieve from './views/Retrieve.vue';
import IdentityVerificationFailure from './views/IdentityVerificationFailure.vue';
import PromotionalIneligible from './views/PromotionalIneligible.vue';
import PasswordResetInstructions from './views/PasswordResetInstructions.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/agree-to-terms',
      name: 'agree-to-terms',
      component: AgreeToTerms,
    },
    {
      path: '/employment-information',
      name: 'employment-information',
      component: EmploymentInformation,
    },
    {
      path: '/final-page',
      name: 'final-page',
      component: FinalPage,
    },
    {
      path: '/final-page-irrl',
      name: 'final-page-irrl',
      component: FinalPageIRRL,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/minor-login-error',
      name: 'minor-login-error',
      component: MinorLoginError,
    },
    {
      path: '/personal-information-is',
      name: 'personal-information-is',
      component: PersonalInformationIS,
    },
    {
      path: '/personal-information',
      name: 'personal-information',
      component: PersonalInformation,
    },
    {
      path: '/review-and-confirm-is',
      name: 'review-and-confirm-is',
      component: ReviewAndConfirmIS,
    },
    {
      path: '/review-and-confirm',
      name: 'review-and-confirm',
      component: ReviewAndConfirm,
    },
    {
      path: '/trust-review-and-confirm',
      name: 'trust-review-and-confirm',
      component: TrustReviewAndConfirm,
    },
    {
      path: '/session-timeout',
      name: 'session-timeout',
      component: SessionTimeOut,
    },
    {
      path: '/system-error',
      name: 'system-error',
      component: SystemError,
    },
    {
      path: '/welcome-back',
      name: 'welcome-back',
      component: WelcomeBack,
    },
    {
      path: '/customer-igo',
      name: 'customer-igo',
      component: CustomerIGO,
    },
    {
      path: '/joint-employment-information',
      name: 'joint-employment-information',
      component: JointEmploymentInformation,
    },
    {
      path: '/joint-personal-information',
      name: 'joint-personal-information',
      component: JointPersonalInformation,
    },
    {
      path: '/joint-contact-information',
      name: 'joint-contact-information',
      component: JointContactInformation,
    },
    {
      path: '/eligible-account-error',
      name: 'eligible-account-error',
      component: EligibleAccountError,
    },
    {
      path: '/trust-login',
      name: 'trust-login',
      component: TrustLogin,
    },
    {
      path: '/trust-information',
      name: 'trust-information',
      component: TrustInformation,
    },
    {
      path: '/trust-role',
      name: 'trust-role',
      component: TrustRole,
    },
    {
      path: '/trust-dashboard',
      name: 'trust-dashboard',
      component: TrustDashboard,
    },
    {
      path: '/trust-ssn-mismatch',
      name: 'trust-ssn-mismatch',
      component: TrustSsnMismatch,
    },
    {
      path: '/trust-additional-role',
      name: 'trust-additional-role',
      component: TrustAdditionalRole,
    },
    {
      path: '/trust-authority',
      name: 'trust-authority',
      component: TrustAuthority,
    },
    {
      path: '/trust-paper',
      name: 'trust-paper',
      component: TrustPaper,
    },
    {
      path: '/trust-signing',
      name: 'trust-signing',
      component: TrustSigning,
    },
    {
      path: '/trust-final-page',
      name: 'trust-final-page',
      component: TrustFinalPage,
    },
    {
      path: '/trust-retrieve-page',
      name: 'trust-retrieve-page',
      component: TrustRetrievePage,
    },
    {
      path: '/trust-pending-record',
      name: 'trust-pending-record',
      component: TrustPendingRecord,
    },
    {
      path: '/trust-next-steps',
      name: 'trust-next-steps',
      component: TrustNextSteps,
    },
    {
      path: '/trust-email-dashboard',
      name: 'trust-email-dashboard',
      component: TrustEmailDashboard,
    },
    {
      path: '/trust-email-dashboard-ecta',
      name: 'trust-email-dashboard-ecta',
      component: TrustEmailDashboardEcta,
    },
    {
      path: '/trust-back-to-maestro',
      name: 'trust-back-to-maestro',
      component: TrustBackToMaestro,
    },
    {
      path: '/trust-not-editable-error',
      name: 'trust-not-editable-error',
      component: TrustNotEditableError,
    },
    {
      path: '/retrieve',
      name: 'retrieve',
      component: Retrieve,
    },
    {
      path: '/identity-verification-failure',
      name: 'identity-verification-failure',
      component: IdentityVerificationFailure,
    },
    {
      path: '/promotional-ineligible',
      name: 'promotional-ineligible',
      component: PromotionalIneligible,
    },
    {
      path: '/password-reset-instructions',
      name: 'password-reset-instructions',
      component: PasswordResetInstructions,
    },
    {
      path: '/trust-doc-verify-wait',
      name: 'trust-doc-verify-wait',
      component: TrustDocVerifyWait,
    },
    {
      path: '/trust-doc-verify-initiate',
      name: 'trust-doc-verify-initiate',
      component: TrustDocVerifyInitiate,
    },
    {
      path: '/trust-doc-verify-resend-sms',
      name: 'trust-doc-verify-resend-sms',
      component: TrustDocVerifyResendSMS,
    },
    {
      path: '/trust-identity-verification-failure',
      name: 'trust-identity-verification-failure',
      component: TrustIdentityVerificationFailure,
    },
    {
      path: '/trust-doc-verify-not-complete',
      name: 'trust-doc-verify-not-complete',
      component: TrustDocVerifyNotComplete,
    },
    {
      path: '/trust-customer-contact-mismatch',
      name: 'trust-customer-contact-mismatch',
      component: TrustCustomerContactMisMatch,
    },
    {
      path: '/trust-customer-identity-mismatch',
      name: 'trust-customer-identity-mismatch',
      component: TrustCustomerIdentityMisMatch,
    },
    {
      path: '/trust-customer-not-found',
      name: 'trust-customer-not-found',
      component: TrustCustomerNotFound,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
